import type { ISbStoryData } from '@storyblok/js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface SbContentMutator<Content extends Record<string, any> = any> {
	check: (fieldName: string, content: ISbStoryData['content']) => boolean;
	mutate: (fieldName: string, content: ISbStoryData<Content>['content']) => Promise<void>;
}

async function mutateContent(
	fieldName: string,
	content: ISbStoryData['content'],
	mutators: Array<SbContentMutator>
): Promise<void> {
	const validMutators = mutators.filter(m => m.check(fieldName, content))
	await Promise.all(validMutators.map(m => m.mutate(fieldName, content)))
}

export async function mutateComponents(
	content: ISbStoryData['content'],
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	mutators: Array<SbContentMutator<any>>,
	key = 'content'
): Promise<void> {
	if (!content) return;

	if (Array.isArray(content)) {
		await Promise.all(content.map((item) => mutateComponents(item, mutators, key)));
		return;
	}

	if (typeof content !== 'object') return;

	await Promise.all([
		mutateContent(key, content, mutators),
		...Object.entries(content).reduce<Array<Promise<void>>>((acc, [subKey, value]) => {
			if (value && typeof value === 'object') {
				acc.push(mutateComponents(value, mutators, subKey))
			}
			return acc;
		}, [])]);
}
